import * as actionTypes from './actionTypes'

export const changeLanguage = (language) => ({
    type: actionTypes.CHANGE_LANGUAGE,
    payload: language
})